import { forwardRef, useEffect, useState } from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ChevronLeft, ChevronRight } from 'react-bootstrap-icons';
import { Trans } from '@lingui/react/macro';
import useScreenSize from 'hooks/useScreenSize';

import 'swiper/css';
import 'swiper/css/navigation';

export const ProductSwiper = forwardRef(
  (
    {
      teeTypes,
      teeName,
      isTeeAvailable,
      initialSlide,
      onSlideChange,
      imgWidth,
      imgHeight,
      isLoading,
    },
    ref
  ) => {
    const [isArrowsVisible, setIsArrowsVisible] = useState(false);
    const { width } = useScreenSize();
    const isSmallScreen = width < 768;

    useEffect(() => {
      isSmallScreen && !isArrowsVisible && setIsArrowsVisible(true);
      !isSmallScreen && isArrowsVisible && setIsArrowsVisible(false);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSmallScreen]);

    return (
      <div
        className="relative"
        onMouseEnter={() => !isSmallScreen && setIsArrowsVisible(true)}
        onMouseLeave={() => !isSmallScreen && setIsArrowsVisible(false)}
      >
        {!isLoading && isTeeAvailable ? (
          <Swiper
            ref={ref}
            modules={[Navigation]}
            loop
            navigation={{
              nextEl: '.custom-swiper-btn-next',
              prevEl: '.custom-swiper-btn-prev',
            }}
            onSlideChange={onSlideChange}
            initialSlide={initialSlide}
          >
            {teeTypes.map(({ name, imgUrl }) => (
              <SwiperSlide className="!w-full" key={name}>
                <img
                  className="cursor-pointer w-full"
                  width={imgWidth}
                  height={imgHeight}
                  src={imgUrl}
                  alt={teeName}
                  onClick={() => ref.current.swiper.slideNext()}
                />
              </SwiperSlide>
            ))}
            {isTeeAvailable && (
              <>
                <div
                  className="custom-swiper-btn-next absolute z-10 top-1/2 right-2 transform -translate-y-1/2 cursor-pointer h-9 w-9 bg-white hover:bg-gray-400 active:bg-gray-500"
                  style={{ visibility: isArrowsVisible ? 'visible' : 'hidden' }}
                >
                  <ChevronRight className="fill-qw-black h-9 w-9" />
                </div>
                <div
                  className="custom-swiper-btn-prev absolute z-10 top-1/2 left-2 transform -translate-y-1/2 cursor-pointer h-9 w-9 bg-white hover:bg-gray-400 active:bg-gray-500"
                  style={{ visibility: isArrowsVisible ? 'visible' : 'hidden' }}
                >
                  <ChevronLeft className="fill-qw-black h-9 w-9" />
                </div>
              </>
            )}
          </Swiper>
        ) : (
          <div className="aspect-[450/540] flex items-center justify-center bg-slate-200">
            {!isLoading && (
              <span>
                <Trans>Tee is unavailable</Trans>
              </span>
            )}
          </div>
        )}
      </div>
    );
  }
);
